/* storybook-check-ignore */
import React, { useState } from 'react';
import Header from '../../shared/Header';
import MenuPanel, { MenuOverlay } from '../../shared/MenuPanel';
import { CustomGlobalStyles } from '../../shared/GlobalStyles';
import { colors } from '@opendoor/bricks/theme/eero';
import Head from 'next/head';

// subset of the full GlobalStyles css, mostly just needed so we can use
// the shared Header, ideally that would be rewritten to use bricks components
// and then we would need this
// resetting the margin/padding is also important so we can use proper
// percentages for the sticky sidebar without a visual shift
const customGlobalCss = `
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
body {
  margin: 0 auto;
  padding: 0;
  font: 400 16px/1.7 Graphik, sans-serif;
}

input,
button {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

a {
  color: ${colors.brand50};
  text-decoration: none;
  font: 400 16px/1.7 Graphik, sans-serif;
}
`;

const Layout: React.FC<{ seoHead?: React.ReactNode }> = ({ children, seoHead }) => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const toggleMenuOpen = () => setMenuOpen(!isMenuOpen);

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://cabinet-production-public.imgix.net" />
        <link rel="dns-prefetch" href="https://cabinet-production-public.imgix.net" />
        <link rel="preconnect" href="https://cdn-cosmos.opendoor.com" />
        <link rel="dns-prefetch" href="https://cdn-cosmos.opendoor.com" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta httpEquiv="Accept-CH" content="DPR, Width, Viewport-Width" />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="https://www.opendoor.com/apple-touch-icon-144.png"
        />
      </Head>
      {seoHead}
      <CustomGlobalStyles customCss={customGlobalCss} />
      <MenuPanel active={isMenuOpen} toggleMenuOpen={toggleMenuOpen} />
      <MenuOverlay onClick={toggleMenuOpen} active={isMenuOpen} />
      <Header isMenuOpen={isMenuOpen} toggleMenuOpen={toggleMenuOpen} />
      <main tabIndex={-1}>{children}</main>
    </>
  );
};

export default Layout;
